module.exports = __webpack_public_path__ + "static/img/join-05.abd71a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join-05.png
// module id = Iwrt
// module chunks = 10